import { Component } from '@angular/core';
import { Platform, Config } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TranslateService } from '@ngx-translate/core';
import { ConfigDataProvider } from '../providers/config-data/config-data';
import { DatabaseProvider } from '../providers/database/database';
import { SyncProvider } from '../providers/sync/sync';
import { MessagesStoreProvider } from '../providers/messages-store/messages-store';
import { CalendarItemsStoreProvider } from '../providers/calendar-items-store/calendar-items-store';
import { TasksStoreProvider } from '../providers/tasks-store/tasks-store';
import moment from "moment";
import 'moment/src/locale/fr';
import 'moment/src/locale/nl';

@Component({
	templateUrl: 'app.html'
})
export class MyApp {
	rootPage: String = "DashboardPage";

	constructor(
		platform: Platform,
		statusBar: StatusBar,
		splashScreen: SplashScreen,
		private translate: TranslateService,
		private configDataProvider: ConfigDataProvider,
		private databaseProvider: DatabaseProvider,
		private messagesStore: MessagesStoreProvider,
		private calendarItemsStore: CalendarItemsStoreProvider,
		private tasksStore: TasksStoreProvider,
		private sync: SyncProvider,
		private config: Config
	) {
		platform.ready().then(() => {

			localStorage.setItem('caredocurl', "https://login.opyx.net")

			let lang = this.configDataProvider.getLanguageType();
			let defaluatLang = lang ? lang : "en"
			
			moment.locale(defaluatLang);

			config.set('monthNames', moment.months())
      config.set('monthShortNames', moment.monthsShort())
      config.set('dayNames', moment.weekdays())
      config.set('dayShortNames', moment.weekdaysShort())
			this.translate.addLangs(["en","fr","nl"])
			this.translate.setDefaultLang(defaluatLang);
			// Okay, so the platform is ready and our plugins are available.
			// Here you can do any higher level native things you might need.

			splashScreen.hide();
			statusBar.overlaysWebView(false);
			statusBar.backgroundColorByHexString("#3b5b7b");
			statusBar.styleDefault();
			statusBar.styleLightContent();


			/** 
			 * 
			 * The below code for SYNC Messages, Tasks and Events Items to Server.
			 * Process of syncing list is continue in background.
			 * 
			 * @var {syncMessagesObservable$} -> is for sync new and updated messages list to server. 
			 * 
			 * @var {syncTasksObservable$} -> is for sync new and updated tasks list to server.
			 * 
			 * @var {syncEventsObservable$} -> is for sync new and updated events list to server.
			 * 
			 */

			this.messagesStore.syncMessagesObservable$.subscribe((res) => {

				if (res) {
					this.sync.syncMessages();
				}

			});

			this.tasksStore.syncTasksObservable$.subscribe((res) => {

				if (res) {
					this.sync.syncTasks();
				}

			});

			this.calendarItemsStore.syncEventsObservable$.subscribe((res) => {

				if (res) {
					this.sync.syncEvents();
				}

			});


			/**
			 * 
			 * 
			 * Get latest data from server in every 10 minutes
			 * 
			 * Application data is updated in background in every 10 minutes of time period
			 * 
			 * This will update @messages and  @tasks and @attachments and  @calendaritems table details
			 * 
			 * 
			 */

			setInterval(() => {

				let user = this.configDataProvider.getUserData();
				
				if (user && user.id) {
					this.sync.syncCritical().subscribe(() => {

					}, () => { })
				}

			}, 180000)

		});
	}
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts